// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .add-engagement .p-autocomplete .p-autocomplete-input-multiple, .add-engagement .p-autocomplete{
    padding-left: 0;
    text-indent: 7px;
}

.w-100 {
    font-size: small;
    color: #646262;
}

.cancel:hover {
    background-color:#666 !important;
  }

  ::ng-deep .add-engagement .radiobtn label {
    position: relative;
    bottom: 0;
  }

 :host ::ng-deep .hinttext1{
    font-size: 10px;
    color: #333;
    line-height: 0px;
    left: 5px;
    position: relative;
    bottom: 0;
  }
  :host ::ng-deep .hinttext{
    font-size: 10px;
    color: #333;
    line-height: normal;
    position: revert;
    margin-left:10px;
    align-items: center;
    display: flex;
  }

  .row {
    display: flex;
  }
  .p-autocomplete-chip-item{
        background: #ccc;
    font-size: 12px;
    color: #212529;
    padding: 3px;
    border-radius: 0.25rem;
    .ui-autocomplete-token-label{
      font-size: 12px;
    }
  }
  
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
